/* nsi-cart-drawer.js: the NSI cart drawer. sections/nsi-cart-drawer.liquid renders the markup and
   window.NSI_CD_CFG; this file is the logic, cached, instead of 27KB inline on every page (17 Sep 2026). */
(function () {
  var root = document.getElementById('nsi-cart-drawer');
  if (!root) return;
  var THRESHOLD = parseInt(root.getAttribute('data-threshold'), 10) || 0;
  var GIFT_THR = parseInt(root.getAttribute('data-gift-threshold'), 10) || 0;
  var GIFT_VARIANT = parseInt(root.getAttribute('data-gift-variant'), 10) || null;
  var IS_TRADE = root.hasAttribute('data-nsi-trade');
  var ADDONS = NSI_CD_CFG.addons;
  var ADDON_MAX_GAP = 2500;   /* show add-ons only when the next step is $25 or less away */
  /* A drawn gift box, not an emoji, so it renders the same on every phone and desktop. */
  var GIFT_ICON = '<svg class="nsi-cd__gift-ico" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false"><path d="M3.5 10h17v10.5h-17z M2.5 6.5h19V10h-19z M12 6.5v14 M12 6.5c-2.6 0-4.6-1.3-4.6-2.7S9.4 1.8 12 6.5c2.6-4.7 4.6-3.9 4.6-2.7S14.6 6.5 12 6.5z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  var GIFT_MSG = GIFT_ICON + ' ' + NSI_CD_CFG.giftMsg;
  var GIFT_THEN_SHIP = GIFT_ICON + ' ' + NSI_CD_CFG.giftThenShip;
  var BOTH_UNLOCKED = GIFT_ICON + ' ' + NSI_CD_CFG.bothUnlocked;
  var GIFT_REMOVED_NOTE = NSI_CD_CFG.giftRemovedNote;
  var giftBusy = false;
  /* The gift marker sits at GIFT_POS% of the track, not at $99/$150 (66%), so it reads as the
     first step rather than crowding the free shipping end. The fill is drawn in two segments to
     match: $0 to the gift threshold covers 0 to GIFT_POS%, the gift threshold to free shipping
     covers the rest. Slightly slower before the gift, faster after. (Andrew, 17 Sep 2026) */
  var GIFT_POS = 55;
  function fillPct(basis, twoStep) {
    if (!twoStep) return Math.min(100, Math.round(basis / THRESHOLD * 100));
    if (basis <= GIFT_THR) return Math.round(basis / GIFT_THR * GIFT_POS);
    return Math.min(100, Math.round(GIFT_POS + (basis - GIFT_THR) / (THRESHOLD - GIFT_THR) * (100 - GIFT_POS)));
  }
  var INS_VARIANT = parseInt(root.getAttribute('data-insurance-variant'), 10) || null;
  var panel = root.querySelector('.nsi-cd__panel');
  var els = {
    items: root.querySelector('[data-nsi-cd-items]'),
    empty: root.querySelector('[data-nsi-cd-empty]'),
    foot: root.querySelector('[data-nsi-cd-foot]'),
    ship: root.querySelector('[data-nsi-cd-ship]'),
    shipMsg: root.querySelector('[data-nsi-cd-ship-msg]'),
    shipGoal: root.querySelector('[data-nsi-cd-ship-goal]'),
    shipFill: root.querySelector('[data-nsi-cd-ship-fill]'),
    giftStep: root.querySelector('[data-nsi-cd-gift-step]'),
    addons: root.querySelector('[data-nsi-cd-addons]'),
    addonsRow: root.querySelector('[data-nsi-cd-addons-row]'),
    count: root.querySelector('[data-nsi-cd-count]'),
    subtotal: root.querySelector('[data-nsi-cd-subtotal]'),
    insurance: root.querySelector('[data-nsi-cd-insurance]'),
    notice: root.querySelector('[data-nsi-cd-notice]'),
    noticeWrap: root.querySelector('[data-nsi-cd-noticewrap]'),
    loading: root.querySelector('[data-nsi-cd-loading]')
  };
  var CART = null, busy = false, lastKeys = '';
  /* Instant paint (17 Sep 2026): the last cart this browser saw, so the count and the rows are on
     screen before /cart.js answers. Marked __cached so the gift sync waits for the real cart. */
  try { var nsiCached = JSON.parse(sessionStorage.getItem('nsi_cd_cart') || 'null'); if (nsiCached && nsiCached.items) { nsiCached.__cached = true; CART = nsiCached; } } catch (e) {}
  /* true from the moment an add fires until the cart data that includes it lands */
  var awaitingCart = false;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function isInsurance(item) { return INS_VARIANT && item.variant_id === INS_VARIANT; }
  function isGift(item) { return GIFT_VARIANT && item.variant_id === GIFT_VARIANT; }

  // ---- Trade pricing -------------------------------------------------------
  // Shopify's cart always holds the retail price: BSS applies the trade rule when it swaps
  // checkout for a draft order, so /cart.js can never show it. We mirror the rule here so the
  // drawer shows the number the customer will actually pay. Same maths as product-price.liquid
  // (round half up per unit, then x qty) and the same `no-trade` exclusion.
  var TRADE_RATE = parseInt(root.getAttribute('data-nsi-trade-rate'), 10) || 0;
  var NO_TRADE = Object.create(null);   // handle -> true when the product is excluded
  var COMPARE_AT = Object.create(null); // variant id -> compare-at price in cents
  var tagsPending = false;

  function handleOf(item) {
    var m = /\/products\/([^?#\/]+)/.exec(item.url || '');
    return m ? m[1] : '';
  }
  function isExcluded(item) { return NO_TRADE[handleOf(item)] !== false; }
  function tradePrice(item) {
    if (!TRADE_RATE || isExcluded(item)) return item.final_line_price;
    return Math.round(item.final_price * (100 - TRADE_RATE) / 100) * item.quantity;
  }
  /* Three tiers, matching the product, collection and cart pages (Zac, 2026-09-10):
       original (grey, struck) -> marked down (green, struck) -> trade (purple)
     Emits the same .nsi-trade-price__* classes as the Liquid line, so the colours in
     nsi-site.css apply here without a second set of rules that could drift.
     `trade < sale` is a guard: at a zero or meaningless rate the trade figure equals the
     sale figure, and showing an identical "discount" struck against itself is misleading. */
  function priceHTML(item) {
    var trade = tradePrice(item);
    var sale = item.final_line_price;
    var orig = item.original_line_price;
    var onSale = orig > sale;
    var isTrade = !!TRADE_RATE && !isExcluded(item) && trade < sale;

    /* compare-at beats original_line_price: on a marked-down product Shopify reports
       original_line_price === final_line_price, so onSale was always false and the drawer
       showed a bare price with no strike. */
    var cmp = COMPARE_AT[item.variant_id];
    if (cmp && cmp * item.quantity > sale) { orig = cmp * item.quantity; onSale = true; }

    if (!isTrade) {
      return (onSale
        ? '<s class="nsi-cd__was">' + money(orig) + '</s> <span class="nsi-cd__markdown">' + money(sale) + '</span>'
        : money(sale));
    }
    return '<span class="nsi-trade-price' + (onSale ? '' : ' nsi-trade-price--nosale') + '">'
      /* emitted even when there is no markdown (hidden), so the CSS guard that keeps the
         middle tier grey on a full-price line can match - see nsi-site.css */
      + (onSale ? '<s class="nsi-trade-price__compare">' + money(orig) + '</s>'
                : '<s class="nsi-trade-price__compare" hidden></s>')
      + '<s class="nsi-trade-price__was">' + money(sale) + '</s>'
      + '<span class="nsi-trade-price__slash" aria-hidden="true">/</span>'
      + '<span class="nsi-trade-price__now">' + money(trade) + '</span>'
      + '</span>';
  }
  function subtotalOf(list) {
    return list.reduce(function (a, i) { return a + tradePrice(i); }, 0);
  }
  // /cart.js carries no product tags, so resolve each handle once from the product JSON.
  // Anything we cannot read stays excluded (retail) rather than showing a price BSS may not honour.
  function resolveTags(items) {
    var need = [];
    items.forEach(function (i) {
      var h = handleOf(i);
      if (h && !(h in NO_TRADE) && need.indexOf(h) < 0) need.push(h);
    });
    if (!need.length || tagsPending) return;
    tagsPending = true;
    Promise.all(need.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          NO_TRADE[h] = !p || (p.tags || []).some(function (t) { return String(t).toLowerCase() === 'no-trade'; });
          /* /cart.js carries no compare_at_price (verified: the field is absent from line
             items), so the drawer could never show a markdown. Cache it per variant off
             the same request rather than firing a second one. */
          if (p && p.variants) {
            p.variants.forEach(function (v) {
              if (v && v.compare_at_price) COMPARE_AT[v.id] = v.compare_at_price;
            });
          }
        })
        .catch(function () { NO_TRADE[h] = true; });
    })).then(function () { tagsPending = false; render(); });
  }

  function render() {
    if (!CART) return;
    var items = CART.items.filter(function (i) { return !isInsurance(i) && !isGift(i); });
    var insLine = CART.items.filter(isInsurance)[0] || null;
    var giftLine = CART.items.filter(isGift)[0] || null;
    /* Runs for retail too, not just trade: the same product JSON carries compare_at_price,
       which /cart.js omits, and without it a marked-down line renders with no strike.
       It re-renders on completion, so the first paint is never blocked on the fetch. */
    resolveTags(CART.items);
    var shopSubtotal = subtotalOf(items);

    els.count.textContent = items.reduce(function (n, i) { return n + i.quantity; }, 0) || '';
    /* awaitingCart keeps the empty state suppressed and the placeholder up, so an add
       never renders as "nothing in here" on its way in. */
    els.empty.hidden = items.length > 0 || awaitingCart;
    els.foot.hidden = items.length === 0;
    els.ship.hidden = items.length === 0 || !THRESHOLD;
    els.items.hidden = items.length === 0;
    if (els.loading) els.loading.hidden = !awaitingCart;

    if (THRESHOLD && items.length) {
      var remaining = THRESHOLD - shopSubtotal;
      var twoStep = GIFT_THR > 0 && GIFT_THR < THRESHOLD;
      var giftRemaining = GIFT_THR - shopSubtotal;
      if (twoStep && giftRemaining > 0) {
        els.shipMsg.innerHTML = GIFT_MSG.replace('[amount]', money(giftRemaining));
      } else if (twoStep && remaining > 0) {
        els.shipMsg.innerHTML = GIFT_THEN_SHIP.replace('[amount]', money(remaining));
      } else if (twoStep) {
        els.shipMsg.innerHTML = BOTH_UNLOCKED;
      } else {
        els.shipMsg.innerHTML = remaining > 0
          ? NSI_CD_CFG.shipMsg.replace('[amount]', money(remaining))
          : NSI_CD_CFG.shipUnlocked;
      }
      els.shipGoal.textContent = money(THRESHOLD);
      els.shipFill.style.width = fillPct(shopSubtotal, twoStep) + '%';
      root.classList.toggle('nsi-cd--ship-done', remaining <= 0);
      if (els.giftStep) {
        els.giftStep.hidden = !twoStep;
        if (twoStep) {
          els.giftStep.style.left = GIFT_POS + '%';
          els.giftStep.classList.toggle('done', giftRemaining <= 0);
          els.giftStep.querySelector('b').textContent = (NSI_CD_CFG.giftStepLabel) + ' ' + money(GIFT_THR).replace(/\.00$/, '');
        }
      }
      syncGift(shopSubtotal, giftLine);
      renderAddons(twoStep && giftRemaining > 0 ? giftRemaining : remaining);
    } else {
      if (els.addons) els.addons.hidden = true;
      if (!items.length && giftLine) syncGift(0, giftLine);
    }

    // same lines, new numbers -> update in place so nothing re-renders or flickers
    var keys = items.map(function (i) { return i.key; }).join('|') + (giftLine ? '|gift' : '');
    if (keys && keys === lastKeys) {
      items.forEach(function (i) {
        var row = els.items.querySelector('.nsi-cd__item[data-key="' + i.key + '"]');
        if (!row) return;
        row.classList.remove('busy');
        row.querySelector('.nsi-cd__qty span').textContent = i.quantity;
        row.querySelector('.nsi-cd__item-price').innerHTML = priceHTML(i);
      });
      finishRender(items);
      return;
    }
    lastKeys = keys;
    els.items.innerHTML = items.map(function (i) {
      var opts = (i.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
      var img = i.image ? i.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_180x$1$2') : '';
      return '<div class="nsi-cd__item" data-key="' + esc(i.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="nsi-cd__noimg"></span>') +
        '<div class="nsi-cd__item-main">' +
          '<button type="button" class="nsi-cd__item-x" data-nsi-cd-remove aria-label="Remove">&#10005;</button>' +
          '<a class="nsi-cd__item-title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
          (opts ? '<span class="nsi-cd__item-opts">' + opts + '</span>' : '') +
          /* Pre-order note from the line-item property the product form adds (advent, 21 Oct 2026). */
          (i.properties && i.properties['Pre-order'] ? '<span class="nsi-cd__item-opts" style="color:#b433c1">Pre-order: ' + esc(i.properties['Pre-order']) + '</span>' : '') +
          '<div class="nsi-cd__item-row">' +
            '<div class="nsi-cd__qty">' +
              '<button type="button" data-nsi-cd-dec aria-label="Decrease">&minus;</button>' +
              '<span>' + i.quantity + '</span>' +
              '<button type="button" data-nsi-cd-inc aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="nsi-cd__item-price">' + priceHTML(i) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('') + giftRowHTML(giftLine);
    finishRender(items);
  }
  /* The $0 gift as a slim row at the end of the list: picture, "Free gift" tag, no price, no
     stepper, no remove. The meter owns adding and removing it. (Andrew, 17 Sep 2026) */
  function giftRowHTML(line) {
    if (!line) return '';
    var img = line.image ? line.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_180x$1$2') : '';
    return '<div class="nsi-cd__item nsi-cd__item--gift" data-key="' + esc(line.key) + '">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="nsi-cd__noimg"></span>') +
      '<div class="nsi-cd__item-main">' +
        '<span class="nsi-cd__item-title">' + esc(line.product_title) + '</span>' +
        '<span class="nsi-cd__gift-tag">' + (NSI_CD_CFG.giftRowLabel) + '</span>' +
      '</div></div>';
  }

  /* For PayPal's Pay Later message under the checkout button (nsi-paypal-msg.js, 20 Oct 2026). On the subtotal: its
     cents; data-nsi-cd-provisional while any line's trade price is still being looked up (render() prices those lines
     at retail until resolveTags() answers, so that first total isn't what a trade member pays); and whether gift cards
     and other lines that don't ship are over 25% of the items subtotal, PayPal's own rule for showing no Pay Later
     (cartDigitalExceedsLimit in its paypal-messaging.js, copied as is). */
  function paypalAttrs() {
    var s = els.subtotal, dig = 0, sum = 0, missing = false, any = false;
    if (!s) return;
    CART.items.forEach(function (i) {
      if (!i) return;
      var d = i.requires_shipping === false || i.gift_card === true;
      any = any || d;
      if (typeof i.final_line_price !== 'number') { missing = true; return; }
      sum += i.final_line_price;
      if (d) dig += i.final_line_price;
    });
    var base = typeof CART.items_subtotal_price === 'number' ? CART.items_subtotal_price : sum;
    var digital = missing ? any : (base > 0 && dig * 4 > base);
    var prov = !!TRADE_RATE && CART.items.some(function (i) { var h = handleOf(i); return h && !(h in NO_TRADE); });
    s.setAttribute('data-nsi-cd-cents', String(subtotalOf(CART.items)));
    s.setAttribute('data-nsi-cd-digital', digital ? 'true' : 'false');
    if (prov) s.setAttribute('data-nsi-cd-provisional', ''); else s.removeAttribute('data-nsi-cd-provisional');
  }

  function finishRender(items) {
    var insLine = CART.items.filter(isInsurance)[0] || null;
    els.subtotal.textContent = money(subtotalOf(CART.items));
    paypalAttrs();
    if (els.insurance) {
      els.insurance.classList.remove('busy');
      els.insurance.classList.toggle('on', !!insLine);
      els.insurance.setAttribute('aria-checked', insLine ? 'true' : 'false');
    }
    // keep the theme's header count in step. The theme's badge renders the number
    // via ::after reading data-header-cart-count — write the ATTRIBUTE there, never
    // a text node (a text node doubles the digit on top of the pseudo-element).
    var headerCounts = document.querySelectorAll('.cart-count, [data-cart-count], [data-header-cart-count]');
    var n = items.reduce(function (a, i) { return a + i.quantity; }, 0);
    for (var k = 0; k < headerCounts.length; k++) {
      var el = headerCounts[k];
      if (el.hasAttribute('data-header-cart-count')) {
        el.setAttribute('data-header-cart-count', n || '');
        el.textContent = '';
        el.classList.toggle('visible', n > 0);
      } else {
        el.textContent = n || '';
      }
    }
  }

  /* Shopify answers a change it will not make - qty above stock, a sold-out line - with
     HTTP 422 and an error body, {status, message, description}, NOT a cart. That body used
     to be assigned straight into CART, so CART.items was undefined and every tap after it
     threw until the next add refetched /cart.js (client report, 2026-09-11). A non-2xx now
     rejects instead: CART is never touched, e.notice carries Shopify's wording for the strip,
     and the caller refetches /cart.js so the row snaps back to what Shopify really holds. */
  var FAILED = NSI_CD_CFG.failed;
  function cartJSON(r) {
    if (r.ok) return r.json();
    /* a non-JSON body (a 5xx page, a bot challenge) must still reject cleanly */
    return r.json().catch(function () { return {}; }).then(function (err) {
      var e = new Error('HTTP ' + r.status);
      e.notice = err.description || err.message || FAILED;
      throw e;
    });
  }
  /* notice(e) shows the failure behind e - Shopify's own line when there is one, else the
     fallback (a dropped connection rejects with a TypeError whose text is not for shoppers);
     notice() clears the strip. */
  function notice(e) {
    if (!els.notice) return;
    var msg = e ? (e.notice || FAILED) : '';
    els.notice.textContent = msg;
    (els.noticeWrap || els.notice).hidden = !msg;
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(cartJSON)
      .then(function (c) { CART = c; awaitingCart = false; try { sessionStorage.setItem('nsi_cd_cart', JSON.stringify(c)); } catch (e) {} render(); })
      .catch(function () {
        /* never strand the placeholder if the fetch fails - fall back to the truth we have */
        awaitingCart = false;
        render();
      });
  }
  function change(key, qty) {
    if (busy) return; busy = true;
    var row = els.items.querySelector('.nsi-cd__item[data-key="' + key + '"]');
    if (row) row.classList.add('busy');
    if (isInsurance({ variant_id: (CART.items.filter(function (i) { return i.key === key; })[0] || {}).variant_id }) && els.insurance) els.insurance.classList.add('busy');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(cartJSON)
      .then(function (c) { CART = c; notice(); render(); })
      /* refused or offline: say why, then re-sync so the row shows Shopify's quantity */
      .catch(function (e) { notice(e); return refresh(); })
      .finally(function () { busy = false; if (row) row.classList.remove('busy'); });
  }
  /* The gift follows the basis, never the other way round: at or over the gift line the $0
     FREEGIFT product is added once; below it, removed. The shopper sees only the meter state
     change. A gift added by hand under the line is removed with a one-line note. Never for trade
     (no GIFT_VARIANT is rendered), never counted in the basis, and never more than one. */
  /* The gift is SET with /cart/update.js (idempotent: 1 stays 1, 2 becomes 1, 0 removes), never
     added with /cart/add.js, which increments: on 17 Sep this drawer and the cart page each added
     one before the other's landed and a $107 cart carried three gifts. window.__nsiGiftBusy is
     shared with the cart page script so only one of the two acts at a time. */
  function setGift(qty) {
    var u = {}; u[GIFT_VARIANT] = qty;
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) }).then(cartJSON);
  }
  var giftLast = '';   /* the last add/drop attempted against a given cart state; never repeated back to back */
  function syncGift(basis, giftLine) {
    if (!GIFT_VARIANT || giftBusy || window.__nsiGiftBusy || (CART && CART.__cached)) return;
    if (document.body.classList.contains('template-cart')) return;   /* on /cart the page script owns the gift and reloads to show it */
    var want = GIFT_THR > 0 && basis >= GIFT_THR;
    var need = want ? (!giftLine || giftLine.quantity !== 1) : !!giftLine;
    if (!need) { giftLast = ''; return; }
    /* One attempt per cart state (17 Sep 2026 review). If Shopify refuses (gift unpublished, 429,
       5xx, offline) or answers with a cart that still lacks the line, done() re-renders the same
       CART and would fire the identical /cart/update.js again forever. The next real cart change
       (add, +/-, X, open) gets exactly one fresh attempt. */
    var attempt = (want ? 'add' : 'drop') + '|' + CART.items.map(function (i) { return i.key + '/' + i.quantity; }).join(',');
    if (attempt === giftLast) return;
    giftLast = attempt;
    var done = function () { giftBusy = false; window.__nsiGiftBusy = false; render(); };
    giftBusy = true; window.__nsiGiftBusy = true;
    if (want) {
      setGift(1).then(function (c) { if (c && c.items) CART = c; }).catch(function () {}).finally(done);
    } else {
      setGift(0).then(function (c) { if (c && c.items) CART = c; if (basis > 0) notice({ notice: GIFT_REMOVED_NOTE.replace('[amount]', money(GIFT_THR).replace(/\.00$/, '')) }); })
        .catch(function () {}).finally(done);
    }
  }
  /* Add-ons priced at or above the gap, cheapest first, up to three; hidden when the gap is over
     $25, when nothing fits, or when a candidate is already in the cart. */
  function renderAddons(gap) {
    if (!els.addons || !els.addonsRow) return;
    if (IS_TRADE || !ADDONS.length || gap <= 0 || gap > ADDON_MAX_GAP) { els.addons.hidden = true; return; }
    var inCart = {}; CART.items.forEach(function (i) { inCart[i.variant_id] = true; });
    var picks = ADDONS.filter(function (a) { return a.price >= gap && !inCart[a.id]; }).sort(function (a, b) { return a.price - b.price; }).slice(0, 3);
    if (!picks.length) { els.addons.hidden = true; return; }
    els.addonsRow.innerHTML = picks.map(function (a) {
      return '<button type="button" class="nsi-cd__addon" data-nsi-cd-addon="' + a.id + '">' +
        '<img src="' + esc(a.img) + '" alt="" width="44" height="44" loading="lazy">' +
        '<span class="nsi-cd__addon-title">' + esc(a.title) + '</span>' +
        '<span class="nsi-cd__addon-price">' + money(a.price) + '</span>' +
        '<span class="nsi-cd__addon-cta">Add</span></button>';
    }).join('');
    els.addons.hidden = false;
  }
  function addVariant(id, btn) {
    if (busy) return; busy = true;
    if (btn) btn.classList.add('busy');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(cartJSON).then(function () { notice(); }, notice)
      .then(function () { busy = false; return refresh(); })
      .finally(function () { busy = false; if (btn) btn.classList.remove('busy'); });
  }
  function addInsurance() {
    if (busy || !INS_VARIANT) return; busy = true;
    if (els.insurance) els.insurance.classList.add('busy');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: INS_VARIANT, quantity: 1 })
    }).then(cartJSON)
      /* same handling as change(): a refused or offline add says why instead of a toggle
         that silently flips back, and the refresh below clears its busy state either way */
      .then(function () { notice(); }, notice)
      .then(function () { busy = false; return refresh(); })
      .finally(function () { busy = false; });
  }

  // Chat bubbles etc. pin themselves at max z-index and would beat the drawer on
  // DOM order — hide any high-z fixed widget while the cart is open, restore after.
  var hiddenWidgets = [];
  function stashWidgets() {
    var kids = document.body.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el === root || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) >= 100000 && cs.visibility !== 'hidden') {
        el.setAttribute('data-nsi-cd-stashed', '');
        el.style.setProperty('visibility', 'hidden', 'important');
        hiddenWidgets.push(el);
      }
    }
  }
  function restoreWidgets() {
    for (var i = 0; i < hiddenWidgets.length; i++) {
      hiddenWidgets[i].style.removeProperty('visibility');
      hiddenWidgets[i].removeAttribute('data-nsi-cd-stashed');
    }
    hiddenWidgets = [];
  }

  function open() {
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('on'); });
    document.documentElement.classList.add('nsi-cd-lock');
    stashWidgets();
    // some widgets (Smile rewards, chat) mount late — sweep again once settled
    setTimeout(function () { if (!root.hidden) stashWidgets(); }, 700);
    refresh();
    var c = root.querySelector('.nsi-cd__close');
    if (c) c.focus({ preventScroll: true });
  }
  function close() {
    root.classList.remove('on');
    document.documentElement.classList.remove('nsi-cd-lock');
    restoreWidgets();
    setTimeout(function () { root.hidden = true; }, 300);
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-nsi-cd-notice-x]')) { notice(); return; }
    var ao = e.target.closest && e.target.closest('[data-nsi-cd-addon]');
    if (ao) { addVariant(parseInt(ao.getAttribute('data-nsi-cd-addon'), 10), ao); return; }
    if (e.target.closest('[data-nsi-cd-close]')) { close(); return; }
    var item = e.target.closest('.nsi-cd__item');
    if (item) {
      var key = item.getAttribute('data-key');
      var line = (CART.items.filter(function (i) { return i.key === key; })[0] || {});
      if (e.target.closest('[data-nsi-cd-remove]')) return change(key, 0);
      if (e.target.closest('[data-nsi-cd-dec]')) return change(key, Math.max(0, (line.quantity || 1) - 1));
      if (e.target.closest('[data-nsi-cd-inc]')) return change(key, (line.quantity || 0) + 1);
    }
    if (e.target.closest('[data-nsi-cd-insurance]')) {
      var insLine = CART && CART.items.filter(isInsurance)[0];
      return insLine ? change(insLine.key, 0) : addInsurance();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // The header cart icon goes to the FULL CART PAGE (Zac, 2026-09-10). It used to be
  // intercepted here and opened the drawer instead, so there was no way to reach /cart
  // from the header at all. The drawer is now reserved for the moment it is actually
  // useful - straight after an add to cart, below - which is the only time a shopper
  // wants a quick peek rather than the real page.
  // `.site-header-cart-button` is a plain <a href="/cart">, so removing
  // the handler is all that is needed; nothing here was keeping it alive.
  // Anything that genuinely wants the drawer can opt in with [data-nsi-cd-open].
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-nsi-cd-open]');
    if (!opener || e.target.closest('#nsi-cart-drawer')) return;
    e.preventDefault();
    open();
  }, true);
  /* The header cart icon opens the drawer on every page except the cart page itself (Andrew,
     17 Sep 2026: on a phone there was no way to peek at the cart without adding something).
     It stays a real link to /cart underneath, so a modified click (new tab) and any page where
     this script did not run still land on the cart page. */
  if (!/^\/cart(\/|$|\?)/.test(location.pathname + location.search)) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.site-header-cart-button, a[href="' + NSI_CD_CFG.cartUrl + '"].site-header-button');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      open();
    }, true);
  }

  // auto-open after a successful add to cart (fired by nsi-site-tweaks)
  document.addEventListener('nsi:cart:added', function () {
    /* Flag first, then paint, then fetch. The placeholder is on screen in the same frame
       the drawer opens, instead of the drawer showing stale state for a round trip. */
    awaitingCart = true;
    notice(); // the add succeeded, so any earlier refusal on the strip is stale
    if (els.loading) els.loading.hidden = false;
    if (els.empty) els.empty.hidden = true;
    root.hidden ? open() : refresh();
  });

  /* Back/forward cache (20 Oct 2026): a page restored from history still holds the cart it had when the shopper left,
     even if they changed it on the next page. Re-read it, as on a fresh load: the rows, subtotal, header count and the
     PayPal message under the checkout button all follow. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  if (CART) render();   // from the cache, instantly
  refresh(); // header count on load, and the truth
})();
